import React, { useState, useEffect } from 'react';
import {
  Box,
  VStack,
  FormControl,
  FormLabel,
  Input,
  Switch,
  Button,
  Select,
  useToast,
  GridItem,
  Grid,
} from '@chakra-ui/react';

interface UsuarioDetailProps {
  usuarioId: string | null;
  onClose: () => void;
}

const UsuarioDetail: React.FC<UsuarioDetailProps> = ({ usuarioId, onClose }) => {
  const [usuario, setUsuario] = useState<any | null>(null);
  const [puestos, setPuestos] = useState<{ id: string; descripcion: string }[]>([]);
  const toast = useToast();

  useEffect(() => {
    const fetchPuestos = async () => {
      try {
        const response = await fetch('http://52.91.130.91:5000/api/cPuestoRoutes');
        const data = await response.json();
        const habilitados = data.filter((puesto: any) => puesto.habilitado);
        setPuestos(habilitados.map((puesto: any) => ({ id: puesto.id, descripcion: puesto.descripcion })));
      } catch (error) {
        toast({
          title: 'Error',
          description: 'No se pudieron cargar los puestos.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    };

    fetchPuestos();

    if (usuarioId) {
      const fetchUsuario = async () => {
        try {
          const response = await fetch(`http://52.91.130.91:5000/api/usuarios/${usuarioId}`);
          const data = await response.json();
          setUsuario(data[0]);
        } catch (error) {
          toast({
            title: 'Error',
            description: 'No se pudieron cargar los datos del usuario.',
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
        }
      };
      fetchUsuario();
    } else {
      setUsuario({
        idPuesto: '',
        nombre: '',
        primerApellido: '',
        segundoApellido: '',
        usuario: '',
        contrase_a: '',
        email: '',
        noControl: '',
        activo: true,
        usuarioSDE: '',
        contrase_aSDE: '',
        idMunicipio: '',
      });
    }
  }, [usuarioId]);

  const handleSave = async () => {
    try {
      const url = usuarioId
        ? `http://52.91.130.91:5000/api/usuarios/${usuarioId}`
        : `http://52.91.130.91:5000/api/usuarios`;

      const method = usuarioId ? 'PUT' : 'POST';
      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(usuario),
      });

      if (response.ok) {
        toast({
          title: usuarioId ? 'Usuario Actualizado' : 'Usuario Creado',
          description: `El usuario ha sido ${
            usuarioId ? 'actualizado' : 'creado'
          } con éxito.`,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        onClose();
      } else {
        throw new Error('Error en la operación');
      }
    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudo guardar el usuario.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  if (!usuario) return null;

  return (
    <Box p={5}>
      <Grid
    templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)", md: "repeat(2, 1fr)" }}
    gap={4} // Espaciado entre elementos
  >
        <GridItem>
          <FormControl>
            <FormLabel>Puesto</FormLabel>
            <Select
              placeholder="Seleccionar Puesto"
              value={usuario.idPuesto}
              onChange={(e) => setUsuario({ ...usuario, idPuesto: e.target.value })}
            >
              {puestos.map((puesto) => (
                <option key={puesto.id} value={puesto.id}>
                  {puesto.descripcion}
                </option>
              ))}
            </Select>
          </FormControl>
        </GridItem>

        <GridItem>
          <FormControl>
            <FormLabel>Nombre</FormLabel>
            <Input
              value={usuario.nombre}
              onChange={(e) => setUsuario({ ...usuario, nombre: e.target.value })}
            />
          </FormControl>
        </GridItem>

        <GridItem>
          <FormControl>
            <FormLabel>Primer Apellido</FormLabel>
            <Input
              value={usuario.primerApellido}
              onChange={(e) => setUsuario({ ...usuario, primerApellido: e.target.value })}
            />
          </FormControl>
        </GridItem>

        <GridItem>
          <FormControl>
            <FormLabel>Segundo Apellido</FormLabel>
            <Input
              value={usuario.segundoApellido}
              onChange={(e) => setUsuario({ ...usuario, segundoApellido: e.target.value })}
            />
          </FormControl>
        </GridItem>

        <GridItem>
          <FormControl>
            <FormLabel>Usuario</FormLabel>
            <Input
              value={usuario.usuario}
              onChange={(e) => setUsuario({ ...usuario, usuario: e.target.value })}
            />
          </FormControl>
        </GridItem>

        <GridItem>
          <FormControl>
            <FormLabel>Contraseña</FormLabel>
            <Input
              type="password"
              value={usuario.contrase_a}
              onChange={(e) => setUsuario({ ...usuario, contrase_a: e.target.value })}
            />
          </FormControl>
        </GridItem>

        <GridItem>
          <FormControl>
            <FormLabel>Email</FormLabel>
            <Input
              value={usuario.email}
              onChange={(e) => setUsuario({ ...usuario, email: e.target.value })}
            />
          </FormControl>
        </GridItem>

        <GridItem>
          <FormControl display="flex" alignItems="center">
            <FormLabel>Activo</FormLabel>
            <Switch
              isChecked={usuario.activo}
              onChange={(e) => setUsuario({ ...usuario, activo: e.target.checked })}
            />
          </FormControl>
        </GridItem>
      </Grid>

      <Box textAlign="center" mt={6}>
        <Button colorScheme="blue" onClick={handleSave}>
          Guardar
        </Button>
      </Box>
    </Box>
  );
};

export default UsuarioDetail;
